import { Component, Input, OnInit } from "@angular/core";
import {
    RolEncargadoDTO,
    RolRepresentanteDTO,
    Role,
    RolSupervisor,
} from "app/main/apps/shared/interfaces/usuario.interface";
import { config as CONFIG } from "app/app.config";
@Component({
    selector: "app-roles",
    templateUrl: "./roles.component.html",
    styleUrls: ["./roles.component.scss"],
})
export class RolesComponent implements OnInit {
    @Input() roles:
        | Role[]
        | RolEncargadoDTO[]
        | RolRepresentanteDTO[]
        | RolSupervisor[];
    config: any;
    constructor() {
        this.config = CONFIG;
    }

    ngOnInit(): void {}
}
